import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, View, Pressable } from 'react-native';
import QText from './QText';
import { useTheme } from 'react-native-paper';

const TabUserTypeButton = ({ itemList, selectedValue, onPress }) => {
  const theme = useTheme();
  return (
    <View style={styles.tabContainer}>
      <View
        style={[
          styles.tabBorder,
          {
            backgroundColor: theme.colors.onBackground,
            borderColor: theme.colors.outline,
          },
        ]}
      >
        <View style={styles.row}>
          {itemList.map((item, i) => (
            <Pressable
              key={i}
              onPress={() => onPress(item.value)}
              style={[
                styles.btnContainer,
                selectedValue === item.value
                  ? {
                      backgroundColor: theme.colors.blueColor,
                      borderRadius: 25,
                    }
                  : {},
              ]}
            >
              <QText
                style={[styles.txt, { color: theme.colors.secondaryText }]}
              >
                {item.label}
              </QText>
            </Pressable>
          ))}
        </View>
      </View>
    </View>
  );
};

TabUserTypeButton.propTypes = {
  itemList: PropTypes.array,
  selectedValue: PropTypes.string,
  onPress: PropTypes.func,
};

const styles = StyleSheet.create({
  tabContainer: { width: '100%' },
  tabBorder: { borderWidth: 1, borderRadius: 25, padding: 1 },
  row: { flexDirection: 'row', width: '100%' },
  btnContainer: { width: '50%' },
  txt: { paddingVertical: 10, textAlign: 'center' },
});

export default memo(TabUserTypeButton);
